import styled, { createGlobalStyle } from 'styled-components';
import * as S from '@styles/chat/chat.style';
import { getHoveredElementBackground } from '@styles/globalsStyles';
import { CHAT_ROOM_Z_INDEX, STUDENT_SELECTOR_CONTENT_CLASS_NAME } from 'constants/chat';
export const ScheduledMessagePopupHeader = S.ChatRoomHeaderLayout;
export const ScheduledMessagePopupFooter = styled.div.withConfig({
  componentId: "sc-176u8rh-0"
})(["&{", " > div:last-child{", "}}"], {
  "display": "flex",
  "alignItems": "center",
  "justifyContent": "space-between",
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.75rem",
  "paddingBottom": "0.75rem"
}, {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
});
export const ScheduledMessageForm = styled.form.withConfig({
  componentId: "sc-176u8rh-1"
})(["&{", " > div.wrapper{", "}}"], {
  "display": "flex",
  "minHeight": "1px",
  "flexGrow": "1",
  "flexDirection": "column"
}, {
  "display": "flex",
  "minHeight": "1px",
  "flexGrow": "1",
  "flexDirection": "column"
});
export const StudentSelectorGlobalStyle = createGlobalStyle(["[data-radix-popper-content-wrapper]:has(> .", "){", " z-index:", " !important;min-width:auto !important;box-shadow:0px 8px 24px 0px rgba(23,32,42,0.16);[data-radix-menu-content]{", " [data-radix-collection-item]{", " &:hover{background:", ";}> div{", " > span:first-child{", "}> span:last-child{", "}}}}}"], STUDENT_SELECTOR_CONTENT_CLASS_NAME, {
  "height": "fit-content",
  "width": "12rem",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))"
}, CHAT_ROOM_Z_INDEX + 2, {
  "height": "fit-content",
  "maxHeight": "24rem",
  "width": "100%",
  "overflowY": "auto"
}, {
  "display": "flex",
  "cursor": "pointer",
  "alignItems": "center",
  "gap": "0.5rem",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.62rem",
  "paddingBottom": "0.62rem",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500"
}, getHoveredElementBackground('var(--gray-100)'), {
  "display": "flex",
  "alignItems": "center",
  "gap": "0.5rem"
}, {
  "whiteSpace": "nowrap"
}, {
  "flexShrink": "1",
  "overflow": "hidden",
  "textOverflow": "ellipsis",
  "whiteSpace": "nowrap",
  "fontSize": "0.75rem",
  "lineHeight": "0.875rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
});
export const StudentSelector = styled.div.withConfig({
  componentId: "sc-176u8rh-2"
})(["&{", " button{", " &:hover{background:", ";}}}"], {
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "paddingLeft": "1rem",
  "paddingRight": "1rem",
  "paddingTop": "0.5rem",
  "paddingBottom": "0.5rem",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "width": "fit-content",
  "gap": "0.25rem",
  "borderRadius": "0.5rem",
  "padding": "0.5rem",
  "paddingTop": "0.25rem",
  "paddingBottom": "0.25rem",
  "paddingLeft": "0.5rem",
  "paddingRight": "0.25rem",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, getHoveredElementBackground('var(--gray-100)'));
export const MessageTextArea = styled.div.withConfig({
  componentId: "sc-176u8rh-3"
})(["", " >textarea{", "}"], {
  "minHeight": "1px",
  "flexGrow": "1"
}, {
  "height": "100%",
  "width": "100%",
  "resize": "none",
  "padding": "1rem",
  "&::placeholder": {
    "fontSize": "1rem",
    "lineHeight": "1.5rem",
    "fontWeight": "500",
    "--tw-text-opacity": "1",
    "color": "rgb(105 117 134 / var(--tw-text-opacity, 1))"
  },
  "&:focus-visible": {
    "outline": "2px solid transparent",
    "outlineOffset": "2px"
  }
});
export const AdvancedForm = styled.div.withConfig({
  componentId: "sc-176u8rh-4"
})(["&{", " .attach-image{", "}.title{", "}.time{", "}.title{", "}}"], {
  "display": "flex",
  "width": "100%",
  "flexDirection": "column",
  "gap": "1rem",
  "borderTopWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "1rem"
}, {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
}, {
  "display": "flex",
  "flexDirection": "column",
  "gap": "0.5rem"
}, {
  "fontSize": "0.875rem",
  "lineHeight": "1rem",
  "fontWeight": "700",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});
export const ScheduledMessageListItem = styled.div.withConfig({
  componentId: "sc-176u8rh-5"
})(["&{", " &:hover{background:", ";}> div.time,div.recipient{", "}> div.content{", " overflow:hidden;text-overflow:ellipsis;display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;}}"], {
  "display": "flex",
  "width": "100%",
  "cursor": "pointer",
  "flexDirection": "column",
  "gap": "0.5rem",
  "borderBottomWidth": "1px",
  "borderStyle": "solid",
  "--tw-border-opacity": "1",
  "borderColor": "rgb(227 232 239 / var(--tw-border-opacity, 1))",
  "--tw-bg-opacity": "1",
  "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity, 1))",
  "padding": "1rem"
}, getHoveredElementBackground('bg-my-gray-100'), {
  "display": "flex",
  "justifyContent": "space-between",
  "fontSize": "0.8125rem",
  "lineHeight": "1rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(54 65 82 / var(--tw-text-opacity, 1))"
}, {
  "width": "100%",
  "fontSize": "0.875rem",
  "lineHeight": "1.25rem",
  "fontWeight": "500",
  "--tw-text-opacity": "1",
  "color": "rgb(25 32 41 / var(--tw-text-opacity, 1))"
});